import React from 'react'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import {reportsPadding} from './Reports.module.css'

export default function Reports({data}) {
    const {reportsAnnualReportsBlocks, reportsFinancialReportBlocks} = data
    return (
        <div className={`reports-tab-wrap ${reportsPadding}`}>
            <div className='container'>
                <Tabs defaultActiveKey='first'>
                    <Tab eventKey='first' title='ANNUAL REPORTS'>
                        {reportsAnnualReportsBlocks?.map((block, i) => (
                            <div className='reports-row' key={i}>
                                <div className='heading-level-3 blue-color m-0'>
                                    {block.reportsAnnualBlockTitle}
                                </div>
                                {block.reportsAnnualBlockButtonLink && (
                                    <a
                                        href={`https://worldsavvy.org/${block.reportsAnnualBlockButtonLink.filename}`}
                                        target='_blank'
                                        className='btn blue-btn'
                                        rel='noreferrer'
                                    >
                                        {block.reportsAnnualBlockButtonText}
                                    </a>
                                )}
                            </div>
                        ))}
                    </Tab>
                    <Tab eventKey='second' title='Financial Reports'>
                        {reportsFinancialReportBlocks?.map((block, i) => (
                            <div className='reports-row' key={i}>
                                <div className='heading-level-3 blue-color m-0'>
                                    {block.reportsFinancialBlockTitle}
                                </div>
                                {block.reportsFinancialBlockButtonLink && (
                                    <a
                                        href={`https://worldsavvy.org/${block.reportsFinancialBlockButtonLink.filename}`}
                                        target='_blank'
                                        className='btn blue-btn'
                                        rel='noreferrer'
                                    >
                                        {block.reportsFinancialBlockButtonText}
                                    </a>
                                )}
                            </div>
                        ))}
                    </Tab>
                </Tabs>
            </div>
        </div>
    )
}
